var map = {
	"./addresses.svg": 9179,
	"./affiliate.svg": 5254,
	"./businesses.svg": 6449,
	"./payment.svg": 4889,
	"./repositories.svg": 2995,
	"./trace.svg": 5336,
	"./transactions.svg": 7927,
	"./wallet-transactions.svg": 2874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5138;